<section
  [formGroup]="stepForm"
  class="mbs-wizard_form">
  <mbs-list-select
    bindSelected="bunchId"
    id="list-local-or-cloud-storages"
    [tableContentClass]="'cursor-pointer'"
    [invalid]="stepForm.touched && stepForm.invalid"
    [keepState]="true"
    [loadSource]="false"
    [maxHeight]="'336px'"
    [multipleSelect]="false"
    [showCheckboxes]="false"
    [showHeaders]="false"
    [showSearch]="false"
    [selectedData]="stepForm.get('selectedBunch').value || ''"
    [data]="bunches"
    (changeSelected)="changeSelectedHandler($event)"
    (click)="clickHandler()"
    [headers]="headers">
    <ng-template
      mbsTableCell
      let-bunch>
      <div class="d-flex align-items-center py-1 flex-nowrap">
        <img
          [src]="iconMap[planType]"
          alt="Icon" />
        <span class="mx-2">{{ bunch.bunchName }}</span>
        <div *ngIf="cbfMap[bunch.bunchId] && !isRestoreDB">
          <mbs-tag
            [clickable]="false"
            [closable]="false"
            [noBorder]="true"
            [class]="'bg-info-20 border-radius-sm-important text-uppercase fw-semibold'"
            [size]="null">
            {{ 'wizards:legacyTag' | i18next }}
          </mbs-tag>
        </div>
      </div>
    </ng-template>
  </mbs-list-select>

  <ng-template #nothingRestore>
    <mbs-alert
      [type]="mbsPopupType.info"
      [icon]="true"
      class="mb-0">
      {{ 'wizards:backupToRestoreNothingRestoreText' | i18next: { name: typeDisplay[planType] } }}
    </mbs-alert>
  </ng-template>
</section>
